<template>
  <div class="settings">
    <v-container fluid>
      <h1 class="mb-3">
        Channel Configuration
        <v-chip
          v-clipboard:copy="botId"
          class="cursor-pointer"
          v-clipboard:success="onCopy"
          >{{ botId }} <v-icon small class="pl-2">file_copy</v-icon></v-chip
        >
      </h1>
      <div class="card-curvey">
        <v-layout>
          <v-flex xs6> </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs6>
            <label>Direct Line</label>
            <v-text-field class="mt-2" outline v-model="settings.direct_line">
            </v-text-field>
          </v-flex>

          <v-flex xs6>
            <label>External Analytics API URL</label>
            <v-text-field
              class="mt-2"
              outline
              v-model="settings.external_analytics"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs6>
            <label>Secondary External Analytics API URL</label>
            <v-text-field
              class="mt-2"
              outline
              v-model="settings.external_analytics_second"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs6>
            <label>Queue Names</label>
            <v-combobox
              v-model="settings.queueNames"
              :items="[]"
              chips
              outline
              solo
              multiple
            >
            </v-combobox>
          </v-flex>
          <v-flex xs6>
            <label>Disabling Bot Expiration Time (Minutes)</label>
            <v-text-field
              class="mt-2"
              outline
              placeholder="Duration in minutes"
              v-model="settings.disabling_bot_expiration_time"
            />
          </v-flex>
          <v-flex xs6>
            <label>Bot Licence Key</label>
            <v-text-field
              class="mt-2"
              outline
              placeholder="Licence key"
              v-model="settings.licence_id"
            />
          </v-flex>
          <v-flex xs6>
            <label>Time Zone Shift</label>
            <v-text-field
              class="mt-2"
              outline
              type="number"
              placeholder="Time zone shift"
              v-model="settings.timeZoneShift"
            />
          </v-flex>
          <v-flex xs12>
            <label>Follow-up Message</label>
            <!-- Active -->

            <v-switch
              xs3
              style="display: inline-block"
              v-model="settings.followupMessage.active"
            />
            <!-- Only show if active -->
            <div v-if="settings.followupMessage.active">
              <div>
                <label
                  >Message (This will be used to trigger the Follow-up
                  message)</label
                >
                <v-text-field
                  class="mt-2"
                  outline
                  type="text"
                  placeholder="Message"
                  v-model="settings.followupMessage.message"
                />
              </div>

              <div>
                <label>Duration (Minutes)</label>
                <v-text-field
                  class="mt-2"
                  outline
                  type="number"
                  placeholder="Duration"
                  v-model="settings.followupMessage.duration"
                  min="1"
                  max="1440"
                />
              </div>
              <div>
                <label style="display: block">Channels</label>

                <div
                  style="display: inline-block"
                  v-for="channel in followupMessageChannels"
                  :key="channel.id"
                >
                  <v-checkbox
                    v-model="settings.followupMessage.channels"
                    :label="channel.value"
                    :value="channel.id"
                  ></v-checkbox>
                </div>
              </div>
              <div>
                <label
                  >Exclude Blocks (Follow-up message won't be triggered after
                  these blocks)</label
                >

                <div>
                  <select-blocks
                    :excludeBlocks="settings.followupMessage.excludeBlocks"
                    :blocks="blocks"
                    @onBlocksUpdate="handleBlocksUpdate"
                  ></select-blocks>
                </div>

                <!-- <v-btn
                      v-if="index > 0"
                      @click="deleteBlock(index)"
                      class="delete-replay"
                      fab
                      small
                      color=""
                      ><v-icon color="#666">delete_outline</v-icon></v-btn
                    > -->
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>

      <v-flex xs12>
        <v-btn
          large
          round
          color="primary"
          @click="updateSettings"
          :loading="loader"
        >
          Save
        </v-btn>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
import env from "../../../../utils/env";
import langIso from "../../../../utils/langIso";
import selectBlocks from "./selectBlocks";
export default {
  name: "settings",
  components: {
    selectBlocks,
  },
  data() {
    return {
      settings: {
        iframe_link: "",
        direct_line: "",
        facebook_access_token: "",
        external_analytics: "",
        external_analytics_second: "",
        queueNames: [],
        nlp: {},
        facebookConnector: {},
        licence_id: "",
        timeZoneShift: "",
        followupMessage: {
          active: false,
          message: "",
          channels: [],
          duration: 0,
          excludeBlocks: [],
        },
      },

      blocks: [],
      selectedLang: "",
      selectedEngine: "",
      langIso,
      dialog: false,
      tableNumOfRows: 15,
      loader: false,
      errorMessages: {},
      followupMessageChannels: [
        {
          id: "web",
          value: "Web",
        },
        {
          id: "facebook",
          value: "Facebook",
        },
        {
          id: "whatsapp",
          value: "Whatsapp",
        },
        {
          id: "twitter",
          value: "Twitter",
        },
      ],
    };
  },
  async mounted() {
    await this.getSettings();
    this.tableNumOfRows = this.$store.state.settings.pagination.rowsPerPage;
    await this.getBlocks();
  },
  methods: {
    handleBlocksUpdate(val) {
      this.settings.followupMessage.excludeBlocks = val.blocks;
    },
    async getSettings() {
      const response = await this.$http_bot.get("/settings/");

      if (!response.data.nlp) {
        response.data.nlp = {};
      }
      if (!response.data.facebookConnector) {
        response.data.facebookConnector = {
          pages: [],
          selectedPage: "",
          appId: "",
          appSecret: "",
        };
      }
      if (!response.data.followupMessage) {
        response.data.followupMessage = {
          active: false,
          message: "",
          channels: [],
          duration: 0,
          excludeBlocks: [],
        };
      }
      if (this.facebookAutoCred === "true") {
        response.data.facebookConnector.appId = env.FACEBOOK_APP_ID;
      }
      this.settings = response.data;
      this.$store.dispatch("setSettings", this.settings);
    },
    async updateSettings() {
      this.loader = true;
      await this.$http.put("/settings/", {
        bot_id: this.botId,
        settings: this.settings,
      });

      this.$store.dispatch("setSettings", this.settings);
      if (this.settings.facebookConnector.selectedPage.id) {
        this.updateFacebookSelectedPage();
      }
      this.$store.dispatch("setSettings", this.settings);
      this.updateBotLicenceKey();
    },
    async updateBotLicenceKey() {
      await this.$http_session_manager.put(
        `/bots/${this.$store.state.bot.botId}`,
        {
          licence_id: this.settings.licence_id,
        }
      );

      this.loader = false;
      this.$store.dispatch("setSnackbar", {
        text: `Updated successfully `,
        color: "success",
        status: true,
      });
    },
    async updateFacebookSelectedPage() {
      let image = await this.getFacebookPageImage();

      await this.$http_session_manager.put(
        `/bots/${this.$store.state.bot.botId}/apps/facebook`,
        {
          page_id: this.settings.facebookConnector.selectedPage.id,
          app_secret: this.settings.facebookConnector.appSecret
            ? this.settings.facebookConnector.appSecret
            : "",
          access_token:
            this.settings.facebookConnector.selectedPage.access_token,
          name: this.settings.facebookConnector.selectedPage.name,
          verify_token: "",
          image: image.data.data.url,
        }
      );
    },
    async getFacebookPageImage() {
      return this.$http_without_base.get(
        `https://graph.facebook.com/v8.0/${this.settings.facebookConnector.selectedPage.id}/picture?redirect=0`
      );
    },
    pushLang() {
      if (!this.settings.nlp[this.selectedLang]) {
        this.settings.nlp[this.selectedLang] = {
          engine: this.selectedEngine,
          min_score: "",
          app_id: "",
          api_key: "",
          hostname: "",
        };
        this.selectedLang = "";
        this.selectedEngine = "";
        this.dialog = false;
      }
    },
    deleteLang(lang) {
      delete this.settings.nlp[lang];
      this.selectedLang = "";
      this.$forceUpdate();
    },
    getLang(code) {
      let index = this.langIso.findIndex((item) => {
        return item.code === code;
      });
      return this.langIso[index].name;
    },
    onCopy() {
      this.$store.dispatch("setSnackbar", {
        text: "Text copied to your clipboard",
        color: "primary",
        status: true,
      });
    },
    setFacebookPages(pages) {
      this.settings.facebookConnector.pages = pages;
      this.$forceUpdate();
    },
    updateTableNumOfRows() {
      this.$store.dispatch("setTableNumberOfRows", this.tableNumOfRows);
    },
    async getBlocks() {
      const response = await this.$http_bot.get("/blocks");

      this.blocks = response.data;
    },
    deleteBlock(index) {
      this.settings.followupMessage.excludeBlocks.splice(index, 1);
    },
  },

  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
    facebookAutoCred() {
      return env.FACEBOOK_AUTO_PUBLISHER_CREDENTIAL;
    },
  },
};
</script>

<style scoped>
.btn-input {
  height: 45px;
}
.add-lang {
  max-width: 500px;
  margin: auto;
}
</style>
